import { useCallback, useRef } from "react";
import type { CSSProperties } from "react";
import type { Placement } from "@floating-ui/react";
import { FloatingTooltip } from "../Tooltip/FloatingTooltip";

const CLAMP_TOLERANCE_PX = 1;

type ClampedTextProps = {
  text: string;
  as?: "span" | "p" | "div" | "h3";
  className?: string;
  style?: CSSProperties;
  placement?: Placement;
};

export const isClamped = (element: HTMLElement | null): boolean =>
  element !== null && element.scrollHeight - element.clientHeight > CLAMP_TOLERANCE_PX;

export const ClampedText = ({
  text,
  as: Tag = "span",
  className = "",
  style,
  placement,
}: ClampedTextProps) => {
  const elementRef = useRef<HTMLElement | null>(null);
  const setElement = useCallback((node: HTMLElement | null) => {
    elementRef.current = node;
  }, []);

  return (
    <FloatingTooltip
      content={text}
      placement={placement}
      shouldOpen={() => isClamped(elementRef.current)}
      testId="clamped-text-tooltip"
      ariaHidden
    >
      <Tag ref={setElement} className={`line-clamp-2 ${className}`} style={style}>
        {text}
      </Tag>
    </FloatingTooltip>
  );
};
